// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EwVYi","footerContent":"Footer_footerContent__E5RXg","footerLinks":"Footer_footerLinks__Mudwb","footerLink":"Footer_footerLink__xVufR"};